import eventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

eventBus.on('user wants to see logs', function () {
    eventBus.on('challenge view ready', showLogs)
})

function showLogs (challenge) {
    const event = challenge.log_event
    challenge.container.append(levelDuration(event.duration))
    challenge.container.find('.answer input').val(event.answer)

    if (event.eventName === 'wrong_answer') {
        challenge.container.addClass('lose')
    } else if (event.eventName === 'right_answer') {
        challenge.container.addClass('win')
    }
}

function levelDuration (duration) {
    return $('<div>Temps passé : ' + duration + 's</div>')
}
